import styled from 'styled-components'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
`

export const MaxWidthContainer = styled.div`
  max-width: var(--container-max-width);
  padding: 4rem 3rem;
  margin: 0 auto;
`

export const Layout = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;

  @media (min-width: 992px) {
    flex-direction: row;
  }
`
